import { gql } from "@apollo/client";

const GET_CLIENT_CREDIT_DATA = gql`
  query getClientCreditData($clientIdentifier: String!) {
    client(clientIdentifier: $clientIdentifier) {
      id
      identifier
      name
      creditData {
        creditRating {
          creditLimit
          creditsafeScore
          legacyRating
          pdfReportFileId
          probabilityOfDefault
        }
        negativeInformation {
          debtBalance {
            balanceOfPrivateClaims
            balanceOfPublicClaims
            currency
            date
            numberOfPrivateClaims
            numberOfPublicClaims
            totalBalance
            totalClaims
          }
          distraints {
            comment
            date
          }
          latestRecordOfNonPayment {
            date
            typeDescription
          }
          publicClaims {
            amount
            date
          }
          recordOfNonPayment {
            numberOfApplications
            numberOfDistraintOrRepossessions
            numberOfPrivateClaims
            numberOfPublicClaims
            numberOfRevokedApplications
          }
          revokedApplications {
            amount
            comments
            creditor
            creditorCompanyNumber
            creditorForeign
            date
          }
        }
      }
    }
  }
`;

export default GET_CLIENT_CREDIT_DATA;
